import React from 'react';
import './Controls.css';
import { FaPlus, FaEdit, FaTimes, FaSearchPlus, FaSearchMinus, FaFont } from 'react-icons/fa';

const Controls = ({
  tableShape,
  setTableShape,
  seatCount,
  setSeatCount,
  onAddTable,
  isEditing,
  toggleEditing,
  onZoomIn,
  onZoomOut,
  isSectionsLoaded,
  onAddText,
}) => {
  return (
    <div className={`controls-container ${!isEditing ? 'not-editing' : ''}`}>
      <div className="shape-selector">
        <label htmlFor="table-shape">Форма на маса:</label>
        <select
          id="table-shape"
          value={tableShape}
          onChange={(e) => setTableShape(e.target.value)}
          disabled={!isEditing}
        >
          <option value="circle">Круг</option>
          <option value="rectangle">Правоаголник</option>
          <option value="square">Квадрат</option>
        </select>
      </div>

      <div className="seat-control">
        <label htmlFor="seat-count">Број на столици:</label>
        <input
          id="seat-count"
          type="number"
          min="1"
          max="12"
          value={seatCount}
          onChange={(e) => setSeatCount(parseInt(e.target.value) || 1)}
          disabled={!isEditing}
        />
      </div>

      <div className="button-group">
        <button
          className="control-button add-button"
          onClick={onAddTable}
          disabled={!isEditing || !isSectionsLoaded}
        >
          <FaPlus className="control-icon" /> Додади маса
        </button>
        
        <button
          className="control-button add-text-button"
          onClick={onAddText}
          disabled={!isEditing || !isSectionsLoaded}
        >
          <FaFont className="control-icon" /> Додади текст
        </button>
        
        <button
          className={`control-button edit-toggle ${isEditing ? 'active' : ''}`}
          onClick={toggleEditing}
        >
          {isEditing ? (
            <>
              <FaTimes className="control-icon" /> Откажи
            </>
          ) : (
            <>
              <FaEdit className="control-icon" /> Измени
            </>
          )}
        </button>

        <button
          className="control-button zoom-button"
          onClick={onZoomIn}
        >
          <FaSearchPlus className="control-icon" /> +
        </button>

        <button
          className="control-button zoom-button"
          onClick={onZoomOut}
        >
          <FaSearchMinus className="control-icon" /> -
        </button>
      </div>
    </div>
  );
};

export default Controls;